import React, { useCallback, useEffect, useRef, useState } from 'react';
import * as Yup from 'yup';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';

import {
  Divider,
  FormControl,
  FormLabel,
  Grid,
  makeStyles,
  Theme,
  Typography,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@material-ui/core';

import { TextField } from '@mui/material';
import { DesktopDatePicker, LocalizationProvider } from '@mui/lab';

import AdapterDateFns from '@mui/lab/AdapterDateFns';

import moment from 'moment';
import { useHistory, useParams } from 'react-router';
import { green, red } from '@material-ui/core/colors';
import ReactSelect from 'react-select';
import Input from '../../../components/Input';
import { useAxios } from '../../../utils/hooks';
import getValidationErrors from '../../../utils/getValidationErrors';
import { Form as FormModel } from '../../../models/form';
import { Record } from '../../../models/record';
import Loader from '../../../components/Loader';
import CustomCheckbox from '../../../components/Checkbox';
import Snackbar, { AlertComponentProps } from '../../../components/Snackbar';
import { SelectProps } from '../../Records/List/dto';
import { User } from '../../../models/user';
import Signatures from '../../../components/Signatures';
import { SignatureForm } from '../../../models/signature-form';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    background: 'white',
    padding: theme.spacing(3),
    margin: theme.spacing(3),
    marginBottom: theme.spacing(10),
  },
  formTitles: {
    fontWeight: 'bolder',
  },
  formSubTitles: {
    fontWeight: 'normal',
  },
  formControl: {
    margin: theme.spacing(2, 0),
  },
  divider: {
    margin: theme.spacing(2),
  },
  groupTitle: {
    display: 'flex',
    '& span': {
      fontWeight: 'bolder',
    },
  },
}));

const historyItems = [
  {
    name: 'psychologist',
    label: 'Com Psicólogo',
  },
  {
    name: 'psychiatrist',
    label: 'Com Psiquiatra',
  },
  {
    name: 'neuro',
    label: 'Com Neurologista',
  },
  {
    name: 'fono',
    label: 'Com Fonoaudiólogo',
  },
  {
    name: 'psychopedagogue',
    label: 'Com Psicopedagogo',
  },
  {
    name: 'other',
    label: 'Outros',
  },
];

const symtomsList = [
  {
    groupName: 'depression_symptoms',
    groupLabel: 'Sintomas Depressivos',
    subGroups: [
      {
        name: 'tristeza_excessiva_e_prolongada',
        label: 'tristeza excessiva e prolongada',
      },
      {
        name: 'choro',
        label: 'choro',
      },
      {
        name: 'desmotivacao',
        label: 'desmotivação',
      },
      {
        name: 'apatia',
        label: 'apatia',
      },
      {
        name: 'perda_de_interesse_por_atividades',
        label: 'perda de interesse por atividades',
      },
      {
        name: 'baixa_autoestima',
        label: 'baixa autoestima',
      },
      {
        name: 'isolamento',
        label: 'isolamento',
      },
    ],
  },
  {
    groupName: 'school_difficulties',
    groupLabel: 'Dificuldades Relacionadas à Aprendizagem ou Escolares',
    subGroups: [
      {
        name: 'dificuldade_na_aprendizagem',
        label: 'dificuldade na aprendizagem',
      },
      {
        name: 'baixo_rendimento_escolar',
        label: 'baixo rendimento escolar',
      },
      {
        name: 'evasao_escolar',
        label: 'evasão/abandono escolar',
      },
      {
        name: 'repetencia',
        label: 'repetência',
      },
    ],
  },
  {
    groupName: 'development_delay',
    groupLabel: 'Atrasos no Desenvolvimento',
    subGroups: [
      {
        name: 'atraso_na_linguagem',
        label: 'atraso na linguagem',
      },
      {
        name: 'motricidade',
        label: 'motricidade',
      },
      {
        name: 'imaturidade',
        label: 'imaturidade',
      },
      {
        name: 'comportamento_regressivo',
        label: 'comportamento regressivo',
      },
    ],
  },
  {
    groupName: 'humor_change',
    groupLabel: 'Oscilações de Humor',
    subGroups: [
      {
        name: 'labilidade',
        label: 'labilidade',
      },
      {
        name: 'oscilacao',
        label: 'oscilação',
      },
      {
        name: 'instabilidade',
        label: 'instabilidade',
      },
      {
        name: 'disforia',
        label: 'disforia',
      },
      {
        name: 'embotamento',
        label: 'embotamento',
      },
    ],
  },
  {
    groupName: 'intelligence_changes',
    groupLabel: 'Alterações nos Padrões de Inteligência',
    subGroups: [
      {
        name: 'altas_habilidades',
        label: 'altas habilidades',
      },
      {
        name: 'atraso_cognitivo',
        label: 'atraso cognitivo',
      },
    ],
  },
  {
    groupName: 'speech_changes',
    groupLabel: 'Alterações nos Padrões de Fala',
    subGroups: [
      {
        name: 'gagueira',
        label: 'gagueira',
      },
      {
        name: 'mutismo',
        label: 'mutismo',
      },
      {
        name: 'ecolalia',
        label: 'ecolalia',
      },
      {
        name: 'dislalia',
        label: 'dislalia',
      },
      {
        name: 'atraso na fala',
        label: 'atraso na fala',
      },
      {
        name: 'fala_estereotipada',
        label: 'fala estereotipada',
      },
    ],
  },
  {
    groupName: 'ansiety_symtoms',
    groupLabel: 'Sintomas de Ansiedade',
    subGroups: [
      {
        name: 'ansiedade_de_separação',
        label: 'ansiedade de separação',
      },
      {
        name: 'crise_de_panico',
        label: 'crise de pânico',
      },
      {
        name: 'masturbacao_excessiva',
        label: 'masturbação excessiva',
      },
      {
        name: 'comportamento_fobicos',
        label: 'comportamento fóbicos',
      },
    ],
  },
  {
    groupName: 'attention_changes',
    groupLabel: 'Alterações nos Padrões de Atenção',
    subGroups: [
      {
        name: 'desatencao',
        label: 'desatenção',
      },
      {
        name: 'distracao',
        label: 'distração',
      },
      {
        name: 'dificuldade_de_concentracao',
        label: 'dificuldade de concentração',
      },
      {
        name: 'hipo_ou_hipervigil',
        label: 'hipo ou hipervigil',
      },
      {
        name: 'hiper_ou_hipotenaz',
        label: 'hiper ou hipotenaz',
      },
    ],
  },
  {
    groupName: 'perception_changes',
    groupLabel: 'Alterações nos Padrões de Sensopercepção',
    subGroups: [
      {
        name: 'hipo_ou_hiper_sensível_a_toques',
        label: 'desatenção',
      },
      {
        name: 'cheiros',
        label: 'cheiros',
      },
      {
        name: 'barulhos',
        label: 'barulhos',
      },
    ],
  },
  {
    groupName: 'obsessive_behavior',
    groupLabel: 'Comportamento Obsessivo',
    subGroups: [
      {
        name: 'pensamentos_obsessivos',
        label: 'pensamentos obsessivos',
      },
      {
        name: 'rituais',
        label: 'rituais',
      },
      {
        name: 'manias',
        label: 'manias',
      },
      {
        name: 'riso_imotivado',
        label: 'riso imotivado',
      },
      {
        name: 'preocupacoes_excessivas_com_limpeza',
        label: 'preocupações excessivas com limpeza',
      },
    ],
  },
  {
    groupName: 'memory_changes',
    groupLabel: 'Alterações nos Padrões de Memória',
    subGroups: [
      {
        name: 'prejuizos',
        label: 'prejuízos',
      },
      {
        name: 'esquecimento',
        label: 'esquecimento (recente ou remota)',
      },
    ],
  },
  {
    groupName: 'stereotyped_behavior',
    groupLabel: 'Comportamento Estereotipado',
    subGroups: [
      {
        name: 'tiques',
        label: 'tiques',
      },
      {
        name: 'flapping',
        label: 'flapping',
      },
      {
        name: 'comportamento_repetitivos_ou_bizarros',
        label: 'comportamento repetitivos ou bizarros',
      },
      {
        name: 'estereotipia',
        label: 'estereotipia',
      },
    ],
  },
  {
    groupName: 'aggressiveness',
    groupLabel: 'Agressividade',
    subGroups: [
      {
        name: 'brigas',
        label: 'brigas',
      },
      {
        name: 'aggression',
        label: 'agressão (auto e hetero)',
      },
      {
        name: 'automutilacao',
        label: 'automutilação',
      },
      {
        name: 'risco_de_suicidio',
        label: 'risco de suicídio',
      },
    ],
  },
  {
    groupName: 'movement_changes',
    groupLabel: 'Alterações nos Padrões Motores',
    subGroups: [
      {
        name: 'agitation',
        label: 'agitação (inclusive psicomotora)',
      },
      {
        name: 'hipotonia',
        label: 'hipotonia',
      },
      {
        name: 'catatonia',
        label: 'catatonia',
      },
      {
        name: 'inquietacao',
        label: 'inquietação',
      },
      {
        name: 'hiperatividade',
        label: 'hiperatividade',
      },
      {
        name: 'dificuldades_motoras',
        label: 'dificuldades motoras',
      },
    ],
  },
  {
    groupName: 'fear_behavior',
    groupLabel: 'Comportamento Receoso / Temeroso',
    subGroups: [
      {
        name: 'inseguranca',
        label: 'insegurança',
      },
      {
        name: 'timidez_excessiva',
        label: 'timidez excessiva',
      },
      {
        name: 'medo_excessivo',
        label: 'medo_excessivo',
      },
      {
        name: 'retraimento',
        label: 'retraimento',
      },
      {
        name: 'desconfianca',
        label: 'desconfiança',
      },
    ],
  },
  {
    groupName: 'anti_social_behavior',
    groupLabel: 'Comportamento Opositor ou Antisocial',
    subGroups: [
      {
        name: 'dificuldade_com_limites',
        label: 'dificuldade com limites',
      },
      {
        name: 'conduta_opositora',
        label: 'conduta opositora',
      },
      {
        name: 'desafiador',
        label: 'desafiador',
      },
      {
        name: 'fuga',
        label: 'fuga',
      },
      {
        name: 'mentiras',
        label: 'mentiras',
      },
      {
        name: 'furtos',
        label: 'furtos',
      },
      {
        name: 'maltrato_com_animais',
        label: 'maltrato com animais',
      },
    ],
  },
  {
    groupName: 'orientation_changes',
    groupLabel: 'Alterações nos Padrões de Orientação',
    subGroups: [
      {
        name: 'dificuldade_na_organização_espacial',
        label: 'dificuldade na organização espacial',
      },
      {
        name: 'temporal',
        label: 'temporal',
      },
    ],
  },
  {
    groupName: 'dependency_changes',
    groupLabel: 'Alterações nos Padrões de Dependência - Independência',
    subGroups: [
      {
        name: 'coleito',
        label: 'coleito',
      },
      {
        name: 'simbiose',
        label: 'simbiose',
      },
      {
        name: 'dependencia_materna/paterna',
        label: 'dependência materna/paterna',
      },
      {
        name: 'dificuldade_para_fica_ sozinho',
        label: 'dificuldade para ficar sozinho',
      },
    ],
  },
  {
    groupName: 'impulsive_behavior',
    groupLabel: 'Comportamento Impulsivo',
    subGroups: [
      {
        name: 'descontrole_de_impulsos',
        label: 'exposição a situações de riscos',
      },
      {
        name: 'exposicao_a_situacoes_de_riscos',
        label: 'exposição a situações de riscos',
      },
    ],
  },
  {
    groupName: 'thinking_changes',
    groupLabel: 'Alterações nos Padrões de Pensamento e Consciência',
    subGroups: [
      {
        name: 'fuga_de_ideias',
        label: 'fuga de ideias',
      },
      {
        name: 'pensamento_concreto',
        label: 'pensamento concreto',
      },
      {
        name: 'agitacao_psicomotora',
        label: 'agitação psicomotora',
      },
      {
        name: 'pensamento_desorganizado_ou_confuso',
        label: 'pensamento desorganizado ou confuso',
      },
      {
        name: 'falta_de_juizo_critico',
        label: 'falta de juízo crítico',
      },
      {
        name: 'alucinacoes',
        label: 'alucinações',
      },
      {
        name: 'delirios',
        label: 'delírios',
      },
    ],
  },
  {
    groupName: 'relationship_changes',
    groupLabel: 'Alterações nos Padrões de Relacionamentos',
    subGroups: [
      {
        name: 'social_difficulties',
        label: 'dificuldade de socialização ou de interação ex: não ter amigos',
      },
      {
        name: 'isolamento',
        label: 'isolamento',
      },
      {
        name: 'prejuizos_nas_relacoes_familiares',
        label: 'prejuízos nas relações familiares',
      },
    ],
  },
  {
    groupName: 'frustation_tolerancy',
    groupLabel: 'Baixa Tolerância à Frustração',
  },
  {
    groupName: 'sleep_changes',
    groupLabel: 'Alterações nos Padrões de Sono',
    subGroups: [
      {
        name: 'insonia',
        label: 'insônia',
      },
      {
        name: 'dificuldade_para_dormir',
        label: 'dificuldade para dormir',
      },
      {
        name: 'sonambulismo',
        label: 'sonambulismo',
      },
      {
        name: 'terror_noturno',
        label: 'terror noturno',
      },
      {
        name: 'sonolencia',
        label: 'sonolência',
      },
      {
        name: 'sono_agitado',
        label: 'sono agitado',
      },
    ],
  },
  {
    groupName: 'phisycal_symtoms',
    groupLabel: 'Sintomas Físicos',
    subGroups: [
      {
        name: 'vomitos',
        label: 'vômitos',
      },
      {
        name: 'enurese',
        label: 'enurese',
      },
      {
        name: 'encoprese',
        label: 'encoprese',
      },
      {
        name: 'retencao',
        label: 'retenção',
      },
      {
        name: 'alergias',
        label: 'alergias',
      },
      {
        name: 'dores',
        label: 'dores',
      },
      {
        name: 'taquicardia',
        label: 'taquicardia',
      },
      {
        name: 'sudorese',
        label: 'sudorese',
      },
    ],
  },
  {
    groupName: 'food_weight_changes',
    groupLabel: 'Alterações nos Padrões Alimentares e na Imagem Corporal',
    subGroups: [
      {
        name: 'restricao_ou_compulsao_alimentar',
        label: 'restrição ou compulsão alimentar',
      },
      {
        name: 'aumento_ou_perda_de_peso',
        label: 'aumento ou perda de peso',
      },
      {
        name: 'pica',
        label: 'pica',
      },
      {
        name: 'recusa_ou_seletividade_alimentar',
        label: 'recusa ou seletividade alimentar',
      },
      {
        name: 'vomito',
        label: 'vômito',
      },
      {
        name: 'excesso_de_exercicio',
        label: 'excesso de exercício',
      },
      {
        name: 'distorcao_da_imagem_corporal',
        label: 'distorção da imagem corporal',
      },
    ],
  },
  {
    groupName: 'addictive_behaviot',
    groupLabel: 'Comportamento Adictivo',
    subGroups: [
      {
        name: 'uso_ou_abuso_de_substancias',
        label: 'uso ou abuso de substâncias',
      },
      {
        name: 'uso_excessivo_ou_dependencia_de_tecnologias',
        label: 'uso excessivo ou dependência de tecnologias',
      },
    ],
  },
];

const hypotesisList = [
  {
    name: '100',
    label: '100 - Transtorno de Estresse Traumático',
  },
  {
    name: '200',
    label: '200 - Transtorno do Afeto',
  },
  {
    name: '201',
    label: '201 - Transtornos de Ansiedade do bebê e da criança pequena',
  },
  {
    name: '202',
    label: '202 - Transtornos do humor: reação prolongada de perda/pesar',
  },
  {
    name: '203',
    label: '203 - Transtornos do humor: Depressão da infância e Meninice',
  },
  {
    name: '204',
    label: '204 - Transtorno Misto de Expressividade Emocional',
  },
  {
    name: '205',
    label: '205 - Transtornos de Identidade de gênero da Infância',
  },
  {
    name: '206',
    label:
      '206 - Transtorno reativo de privação de vínculo/maus tratos do bebê e da criança pequena',
  },
  {
    name: '300',
    label: '300 - Transtorno de ajustamento',
  },
  {
    name: '400',
    label: '400 - Transtornos regulatórios',
  },
  {
    name: '401',
    label: '401 - Tipo I: Hipersensível',
  },
  {
    name: '402',
    label: '402 - Tipo II: Hiporreativo',
  },
  {
    name: '403',
    label: '403 - Tipo III: Desorganizado do ponto de vista motor, impulsivo',
  },
  {
    name: '404',
    label: '404 - Tipo IV: Outros',
  },
  {
    name: '500',
    label: '500 - Transtorno do comportamento do sono',
  },
  {
    name: '600',
    label: '600 - Transtorno do comportamento alimentar',
  },
  {
    name: '700',
    label:
      '700 - Transtorno de relacionamento e comunicação: Transtorno multissistêmico do desenvolvimento e Transtorno invasivo do desenvolvimento',
  },
];

const hypotesistList2 = [
  {
    name: '901',
    label: '901 - Excessivamente envolvido',
  },
  {
    name: '902',
    label: '902 - Pouco envolvido',
  },
  {
    name: '903',
    label: '903 - Ansioso',
  },
  {
    name: '904',
    label: '904 - Irritado / hostil',
  },
  {
    name: '905',
    label: '905 - Misto',
  },
  {
    name: '906',
    label: '906 - Abusivo',
  },
  {
    name: '906a',
    label: '906 a - Verbalmente abusivo',
  },
  {
    name: '906b',
    label: '906 b - Fisicamente abusivo',
  },
  {
    name: '906c',
    label: '906 c - Sexualmente abusivo',
  },
];

const hypotesistList3 = [
  {
    name: 'eixo3',
    label: 'Eixo III: Transtorno e Condições Orgânicas e do Desenvolvimento',
  },
];

const hypotesistList4 = [
  {
    name: 'eixo4',
    label: 'Eixo IV: Estressores Psicossociais',
  },
];

const hypotesistList5 = [
  {
    name: 'eixo5',
    label: 'Eixo V: Nível de Desenvolvimento Emocional Funcional',
  },

  {
    name: 'eixo5others',
    label: 'Outros diagnósticos não citados acima',
  },

  {
    name: 'eixo5others2',
    label:
      'Outras condições frequentemente associadas a transtornos mentais e de comportamentais',
  },
];

const BabyScreeningForm: React.FC = () => {
  const api = useAxios();
  const classes = useStyles();
  const history = useHistory();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const screeningFormRef = useRef<FormHandles>(null);
  const [proUsers, setProUsers] = useState<SelectProps[]>([]);
  const [coordUsers, setCoordUsers] = useState<SelectProps[]>([]);
  const [signatures, setSignatures] = useState<SignatureForm[]>([]);

  const [form, setForm] = useState<FormModel | null>(null);
  const [record, setRecord] = useState<Record | null>(null);
  const [date, setDate] = useState(new Date());
  const [date_social, setDateSocial] = useState(new Date());
  const [patient_birth, setPatientBirth] = useState(new Date());
  const [professionals, setProfessionals] = useState<SelectProps[]>([]);
  const [coordinators, setCoordinators] = useState<SelectProps[]>([]);

  const { id, formId } = useParams<{ id: string; formId?: string }>();

  const formRef = useRef<FormHandles>(null);

  const [alert, setAlert] = useState<
    AlertComponentProps & { isActive: boolean }
  >({
    isActive: false,
    type: 'info',
    message: 'none',
  });

  useEffect(() => {
    async function getRecordData() {
      try {
        const recordResponse = await api.current?.get(`/records/${id}`);
        setRecord(recordResponse?.data);

        if (formId) {
          const formResponse = await api.current?.get(`/forms/${formId}`);
          if (formResponse?.data) {
            setDate(
              formResponse?.data.answers.date
                ? moment(formResponse?.data.answers.date).toDate()
                : new Date(),
            );
          }
          if (formResponse?.data) {
            setDateSocial(
              formResponse?.data.answers.date_socal
                ? moment(formResponse?.data.answers.date_social).toDate()
                : new Date(),
            );
          }
          if (formResponse?.data) {
            setPatientBirth(
              formResponse?.data.answers.patient_birth
                ? moment(formResponse?.data.answers.patient_birth).toDate()
                : new Date(),
            );
          }
          setForm(formResponse?.data);

          if (
            formResponse?.data.answers &&
            formResponse?.data.answers.signatures
          ) {
            setSignatures(formResponse?.data.answers.signatures);
          }
        }
      } catch (error) {
        setAlert({
          isActive: true,
          type: 'error',
          message: 'Erro ao carregar prontuário.',
        });
      } finally {
        setLoading(false);
      }
    }

    getRecordData();
  }, [api, id, formId]);

  const resetAlert = () => {
    setAlert({
      isActive: false,
      type: 'info',
      message: 'none',
    });
  };

  const handleClickOpen = useCallback(async () => {
    setLoading(true);
    resetAlert();

    try {
      const usersResponse = await api.current?.get('/users');

      if (usersResponse?.data) {
        setProUsers(
          usersResponse.data
            .filter(
              (user: User) =>
                !user.attributes ||
                (user.attributes && !user.attributes.coordenador),
            )
            .map((user: User) => ({
              value: user.id,
              label: `${user.firstName} ${user.lastName}`,
            })),
        );

        setCoordUsers(
          usersResponse.data
            .filter(
              (user: User) =>
                user.attributes &&
                user.attributes.coordenador &&
                user.attributes.coordenador[0] === 'true',
            )
            .map((user: User) => ({
              value: user.id,
              label: `${user.firstName} ${user.lastName}`,
            })),
        );
      }

      setAlert({
        isActive: true,
        type: 'success',
        message: 'Dados de formuário carregados com sucesso.',
      });
    } catch (error) {
      setAlert({
        isActive: true,
        type: 'error',
        message: 'Erro ao carregar dados.',
      });
    } finally {
      setOpen(true);
      setLoading(false);
    }
  }, [api]);

  const handleClose = () => {
    setOpen(false);
  };

  const handleSave = useCallback(
    async (data: any) => {
      try {
        setLoading(true);
        resetAlert();
        setForm({ ...form, answers: data } as FormModel);
        formRef.current?.setErrors({});

        // const schema = Yup.object().shape({
        //   content: Yup.string().required('Insira uma nota'),
        // });

        // await schema.validate(data, { abortEarly: false });
        data.date = moment(date).format('YYYY-MM-DD');
        data.patient_birth = moment(patient_birth).format('YYYY-MM-DD');
        if (data.date_social)
          data.social_date = moment(date).format('YYYY-MM-DD');

        const formRequest = {
          type: 'babyScreening',
          title: 'Parecer da Equipe de Triagem de Pais Bebês',
          // patient: record?.patient._id,
          record: record?._id,
          answers: { ...data, signatures },
        };

        if (formId) {
          await api.current?.patch(`/forms/${formId}`, formRequest);
        } else {
          await api.current?.post('/forms', formRequest);
        }

        setForm({ ...form, answers: data } as FormModel);

        setAlert({
          isActive: true,
          type: 'success',
          message: 'Parecer salvo com sucesso.',
        });
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);

          formRef.current?.setErrors(errors);
        } else {
          setAlert({
            isActive: true,
            type: 'error',
            message: 'Erro ao enviar parecer.',
          });
        }
      } finally {
        setLoading(false);
      }
    },
    [api, record, patient_birth, formId, date, form, signatures],
  );

  const handleSubmitScreening = useCallback(async () => {
    try {
      resetAlert();
      if (!professionals.length && !coordinators.length) {
        throw new Error('Preencha ao menos um terapeuta.');
      }

      await api.current?.patch(`/records/${id}`, {
        professional_id: [
          ...professionals.map((pro) => pro.value),
          ...coordinators.map((coord) => coord.value),
        ],
        professional: [
          ...professionals.map((pro) => pro.label),
          ...coordinators.map((coord) => coord.label),
        ],
      });

      setAlert({
        isActive: true,
        type: 'success',
        message: 'Triagem realizada com sucesso.',
      });
      handleClose();

      history.push(`/prontuarios/${id}`);
    } catch (error) {
      if (error.message === 'Preencha ao menos um terapeuta.') {
        setAlert({
          isActive: true,
          type: 'error',
          message: error.message,
        });
      } else {
        setAlert({
          isActive: true,
          type: 'error',
          message: 'Erro ao realizar triagem.',
        });
      }
    }
  }, [api, history, id, professionals, coordinators]);

  const handleProfessionalSelect = (list: any) => {
    setProfessionals(list);
  };

  const handleCoordinatorSelect = (list: any) => {
    setCoordinators(list);
  };

  const renderList = (list: { name: string; label: string }[]) => {
    return list.map((item) => (
      <>
        <FormControl fullWidth className={classes.formControl}>
          <Divider className={classes.divider} />
        </FormControl>

        <Grid item xs={6}>
          <CustomCheckbox
            name={item.name}
            value={item.name}
            label={item.label}
          />
        </Grid>

        <Grid item xs={6}>
          <Input
            id={`specify_${item.name}`}
            label="Especifique"
            name={`specify_${item.name}`}
          />
        </Grid>
      </>
    ));
  };

  return (
    <>
      <Loader loading={loading} />

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
        fullWidth
      >
        <Form ref={screeningFormRef} onSubmit={handleSubmitScreening}>
          <DialogTitle id="form-dialog-title">Encaminhamento</DialogTitle>

          <Grid item xs={12}>
            <Divider />
          </Grid>

          <DialogContent style={{ minHeight: '40vh' }}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} />

              <Grid item xs={12} />

              <Grid item xs={12}>
                <FormLabel className={classes.formTitles}>
                  Selecione um ou mais terapeutas
                </FormLabel>
              </Grid>

              <Grid item xs={12}>
                <ReactSelect
                  closeMenuOnSelect={false}
                  isMulti
                  options={proUsers}
                  onChange={handleProfessionalSelect}
                  menuPosition="fixed"
                />
              </Grid>

              <Grid item xs={12} />

              <Grid item xs={12}>
                <Divider />
              </Grid>

              <Grid item xs={12} />

              <Grid item xs={12}>
                <FormLabel className={classes.formTitles}>
                  Selecione um ou mais coordenadores
                </FormLabel>
              </Grid>

              <Grid item xs={12}>
                <ReactSelect
                  closeMenuOnSelect={false}
                  isMulti
                  options={coordUsers}
                  onChange={handleCoordinatorSelect}
                  menuPosition="fixed"
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Cancelar</Button>
            <Button type="submit" color="primary" variant="contained">
              Salvar
            </Button>
          </DialogActions>
        </Form>
      </Dialog>

      {!loading && (
        <Form
          id="form"
          ref={formRef}
          initialData={form?.answers || { record: record?.number }}
          onSubmit={handleSave}
          className={classes.root}
        >
          <FormControl fullWidth className={classes.formControl}>
            <Typography
              variant="h5"
              component="h1"
              align="center"
              className={classes.formTitles}
            >
              PARECER DA EQUIPE DE TRIAGEM DE PAIS BEBÊS
            </Typography>

            <Typography
              variant="h6"
              component="h1"
              align="center"
              className={classes.formSubTitles}
            >
              (0 a 3 anos e 11 meses)
            </Typography>

            <Typography
              variant="subtitle2"
              component="span"
              align="center"
              className={classes.formSubTitles}
            >
              (preenchido pela triagem)
            </Typography>

            <Divider className={classes.divider} />
          </FormControl>

          <FormControl fullWidth className={classes.formControl}>
            <Grid container spacing={2}>
              <Grid item xs={4}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DesktopDatePicker
                    label="Data da Triagem"
                    inputFormat="dd/MM/yyyy"
                    value={date}
                    onChange={(d) => setDate(d as Date)}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </LocalizationProvider>
              </Grid>

              <Grid item xs={4} />

              <Grid item xs={4}>
                <CustomCheckbox
                  name="social_service"
                  value="social_service"
                  label="Av.Serviço Social"
                />
              </Grid>

              <Grid item xs={6}>
                <Input
                  id="professional"
                  label="Quem realizou a Triagem"
                  name="professional"
                />
              </Grid>

              <Grid item xs={2} />

              <Grid item xs={4}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DesktopDatePicker
                    label="Data"
                    inputFormat="dd/MM/yyyy"
                    value={date_social}
                    onChange={(d) => setDateSocial(d as Date)}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </LocalizationProvider>
              </Grid>

              <Grid item xs={8} />

              <Grid item xs={4}>
                <Input
                  id="amount"
                  label="Valor"
                  name="amount"
                  placeholder="R$"
                />
              </Grid>
            </Grid>
          </FormControl>

          <FormControl fullWidth className={classes.formControl}>
            <Divider className={classes.divider} />
          </FormControl>

          <FormControl fullWidth className={classes.formControl}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <FormLabel className={classes.formTitles}>
                  Dados de Identificação
                </FormLabel>
              </Grid>
              <Grid item xs={12}>
                <Input id="patient_name" label="Nome" name="patient_name" />
              </Grid>

              <Grid item xs={4}>
                <Input id="patient_age" label="Idade" name="patient_age" />
              </Grid>

              <Grid item xs={4}>
                <Input id="patient_gender" label="Sexo" name="patient_gender" />
              </Grid>

              <Grid item xs={4}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DesktopDatePicker
                    label="Data de Nascimento"
                    inputFormat="dd/MM/yyyy"
                    value={patient_birth}
                    onChange={(d) => setPatientBirth(d as Date)}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </LocalizationProvider>
              </Grid>
            </Grid>
          </FormControl>

          <FormControl fullWidth className={classes.formControl}>
            <Divider className={classes.divider} />
          </FormControl>

          <FormControl fullWidth className={classes.formControl}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <FormLabel className={classes.formTitles}>
                  Indicação de Tratamento
                </FormLabel>
              </Grid>

              <Grid item xs={12}>
                <span>
                  (indicação de tratamento do paciente e/ ou família: para qual
                  terapeuta e/ ou setor(es) foi encaminhado o caso)
                </span>
              </Grid>

              <Grid item xs={6}>
                <CustomCheckbox
                  name="test_psyco"
                  value="test_psyco"
                  label="Avaliação Psicoterápica"
                />
              </Grid>

              <Grid item xs={6}>
                <CustomCheckbox
                  name="food"
                  value="food"
                  label="Setor de transtornos alimentares"
                />
              </Grid>

              <Grid item xs={6}>
                <CustomCheckbox
                  name="body_clinic"
                  value="body_clinic"
                  label="Corpo clínico"
                />
              </Grid>

              <Grid item xs={6}>
                <CustomCheckbox
                  name="psyco_area"
                  value="psyco_area"
                  label="Setor de psicodiagnóstico"
                />
              </Grid>

              <Grid item xs={6}>
                <CustomCheckbox
                  name="env_terapy"
                  value="env_terapy"
                  label="Ambientoterapia"
                />
              </Grid>

              <Grid item xs={6}>
                <CustomCheckbox
                  name="kid_area"
                  value="kid_area"
                  label="Setor de psicopedagogia"
                />
              </Grid>

              <Grid item xs={6}>
                <CustomCheckbox
                  name="adoption"
                  value="adoption"
                  label="Setor de adoção"
                />
              </Grid>

              <Grid item xs={6}>
                <CustomCheckbox
                  name="fono"
                  value="fono"
                  label="Setor de fonoaudiologia"
                />
              </Grid>

              <Grid item xs={6}>
                <CustomCheckbox
                  name="parents"
                  value="parents"
                  label="Setor de atendimento a pais"
                />
              </Grid>

              <Grid item xs={6}>
                <CustomCheckbox
                  name="other_place"
                  value="other_place"
                  label="Para outro local"
                />
              </Grid>

              <Grid item xs={6}>
                <CustomCheckbox
                  name="early"
                  value="early"
                  label="Setor de pais bebês"
                />
              </Grid>

              <Grid item xs={6}>
                <Input id="which_area" label="Qual?" name="which_area" />
              </Grid>

              <Grid item xs={12} />
              <Grid item xs={12} />
              <Grid item xs={12} />

              <Grid item xs={12}>
                <Input
                  id="professional_name"
                  label="Nome do Terapeuta"
                  name="professional_name"
                />
              </Grid>

              <Grid item xs={8}>
                <Input
                  id="interview_date"
                  label="Entrevista marcada para dia"
                  name="interview_date"
                  placeholder="____/____/_______"
                />
              </Grid>

              <Grid item xs={4}>
                <Input
                  id="interview_hour"
                  label="Horário"
                  name="interview_hour"
                />
              </Grid>

              <Grid item xs={6}>
                <Input
                  id="interview_price"
                  label="Valor da consulta"
                  name="interview_price"
                  placeholder="R$"
                />
              </Grid>
            </Grid>
          </FormControl>

          <FormControl fullWidth className={classes.formControl}>
            <Divider className={classes.divider} />
          </FormControl>

          <FormControl fullWidth className={classes.formControl}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <FormLabel className={classes.formTitles}>
                  Dados Coletados Durante a Triagem
                </FormLabel>
              </Grid>

              <Grid item xs={12}>
                <FormLabel className={classes.formTitles}>
                  1) Impressão Geral Transmitida pelo Paciente e/ou Familiar(es)
                </FormLabel>

                <Input
                  id="overview"
                  label="(descrição das primeiras impressões do paciente e da família:
                    quem compareceu, aspectos físicos, humor, comportamento,
                    cuidados pessoais, modo de agir e se expressar. Sentimentos
                    despertados no entrevistador)"
                  name="overview"
                  isMultiline
                  rows={5}
                />
              </Grid>

              <FormControl fullWidth className={classes.formControl}>
                <Divider className={classes.divider} />
              </FormControl>

              <Grid item xs={12}>
                <FormLabel className={classes.formTitles}>
                  2) Motivo da Consulta
                </FormLabel>

                <Input
                  id="motive"
                  label="(motivos descritos pelo paciente e família para a busca de atendimento)"
                  name="motive"
                  isMultiline
                  rows={5}
                />
              </Grid>

              <FormControl fullWidth className={classes.formControl}>
                <Divider className={classes.divider} />
              </FormControl>

              <Grid item xs={12}>
                <FormLabel className={classes.formTitles}>
                  3) Aspectos Familiares
                </FormLabel>

                <Input
                  id="family"
                  label="(o que envolve o paciente e sua família: com quem mora, relacionamento com os pais e irmãos, relacionamento entre os pais, rede de apoio, problemas familiares, etc…)"
                  name="family"
                  isMultiline
                  rows={5}
                />
              </Grid>

              <FormControl fullWidth className={classes.formControl}>
                <Divider className={classes.divider} />
              </FormControl>

              <Grid item xs={12}>
                <FormLabel className={classes.formTitles}>
                  4) Aspectos Escolares
                </FormLabel>

                <Input
                  id="school"
                  label="(adaptação, com que idade ingressou na escola)"
                  name="school"
                  isMultiline
                  rows={5}
                />
              </Grid>

              <FormControl fullWidth className={classes.formControl}>
                <Divider className={classes.divider} />
              </FormControl>

              <Grid item xs={12}>
                <FormLabel className={classes.formTitles}>
                  5) História Pregressa
                </FormLabel>

                <Input
                  id="history"
                  label="(informações fornecidas pela família sobre a história do paciente e/ou família, questões do desenvolvimento, situações importantes da vida do paciente)"
                  name="history"
                  isMultiline
                  rows={5}
                />
              </Grid>

              <FormControl fullWidth className={classes.formControl}>
                <Divider className={classes.divider} />
              </FormControl>

              <Grid item xs={12}>
                <FormLabel className={classes.formTitles}>
                  6) Tratamentos Anteriores
                </FormLabel>

                <Grid container spacing={2}>
                  {historyItems.map((item) => (
                    <>
                      <Grid item xs={4}>
                        <CustomCheckbox
                          name={`with_${item.name}`}
                          value={`with_${item}`}
                          label={item.label}
                        />
                      </Grid>

                      <Grid item xs={4}>
                        <Input
                          id={`which_${item.name}`}
                          label="Quem?"
                          name={`which_${item.name}`}
                        />
                      </Grid>

                      <Grid item xs={4}>
                        <Input
                          id={`when_${item.name}`}
                          label="Quando?"
                          name={`when_${item.name}`}
                        />
                      </Grid>
                    </>
                  ))}
                </Grid>
              </Grid>

              <FormControl fullWidth className={classes.formControl}>
                <Divider className={classes.divider} />
              </FormControl>

              <Grid item xs={12}>
                <FormLabel className={classes.formTitles}>
                  7) Uso de medicação
                </FormLabel>

                <Grid item xs={12}>
                  <CustomCheckbox
                    name="no_medication"
                    value="no_medication"
                    label="Não"
                  />
                </Grid>

                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <CustomCheckbox
                      name="yes_currently"
                      value="yes_currently"
                      label="Sim, atualmente faz uso"
                    />
                  </Grid>

                  <Grid item xs={6}>
                    <Input
                      id="which_yes_currently"
                      label="Qual?"
                      name="which_yes_currently"
                    />
                  </Grid>

                  <Grid item xs={6}>
                    <Input
                      id="when_yes_currently"
                      label="Desde quando?"
                      name="when_yes_currently"
                    />
                  </Grid>
                </Grid>

                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <CustomCheckbox
                      name="yes_in_the_past"
                      value="yes_in_the_past"
                      label="Sim, fez uso anteriormente"
                    />
                  </Grid>

                  <Grid item xs={6}>
                    <Input
                      id="which_yes_in_the_past"
                      label="Qual?"
                      name="which_yes_in_the_past"
                    />
                  </Grid>

                  <Grid item xs={6}>
                    <Input
                      id="when_yes_in_the_past"
                      label="Quando?"
                      name="when_yes_in_the_past"
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <Input
                      id="orientation_yes_in_the_past"
                      label="Qual foi a indicação ou diagnóstico?"
                      name="orientation_yes_in_the_past"
                    />
                  </Grid>
                </Grid>
              </Grid>

              <FormControl fullWidth className={classes.formControl}>
                <Divider className={classes.divider} />
              </FormControl>

              <Grid item xs={12}>
                <FormLabel className={classes.formTitles}>
                  8) Compreensão Psicodinâmica
                </FormLabel>

                <Input
                  id="understanding"
                  label="(compreensão da situação clínica e da dinâmica do funcionamento do paciente e família)"
                  name="understanding"
                  isMultiline
                  rows={5}
                />
              </Grid>

              <FormControl fullWidth className={classes.formControl}>
                <Divider className={classes.divider} />
              </FormControl>

              <Grid item xs={12}>
                <FormLabel className={classes.formTitles}>
                  9) Outras informações obtidas e/ou observadas
                </FormLabel>

                <Input
                  id="observations"
                  label="Observações"
                  name="observations"
                  isMultiline
                  rows={5}
                />
              </Grid>

              <FormControl fullWidth className={classes.formControl}>
                <Divider className={classes.divider} />
              </FormControl>

              <Grid item xs={12}>
                <FormLabel className={classes.formTitles}>
                  10) Recomendações para avaliações adicionais
                </FormLabel>

                <Input
                  id="recomendation"
                  label="(sugestões da equipe de triagem para realização de consultorias familiar/ adoção/ proteção/ transtornos alimentares, etc e/ ou futuros encaminhamentos para o paciente e família)"
                  name="recomendation"
                  isMultiline
                  rows={5}
                />
              </Grid>

              <FormControl fullWidth className={classes.formControl}>
                <Divider className={classes.divider} />
              </FormControl>

              <Grid item xs={12}>
                <FormLabel className={classes.formTitles}>
                  11) Lista de Sintoma
                </FormLabel>
                <br />
                <span>
                  (Padronizada conforme comissão de pesquisa do CEAPIA -
                  referente aos dados levantados nos prontuários ao longo dos 40
                  anos)
                </span>
                <br />
                <br />
                <span>
                  <b>
                    Marque o(s) grupo(s) de sintomas que mais se encaixam com o
                    paciente e também o sintoma identificado.
                  </b>
                </span>

                <FormControl fullWidth className={classes.formControl}>
                  <Divider className={classes.divider} />
                </FormControl>

                {symtomsList.map((group) => (
                  <>
                    <Grid container spacing={2}>
                      <Grid item xs={12} className={classes.groupTitle}>
                        <CustomCheckbox
                          name={group.groupName}
                          value={group.groupName}
                          label={group.groupLabel}
                        />
                      </Grid>

                      {group.subGroups &&
                        group.subGroups.map((subgroup) => (
                          <Grid item xs={4}>
                            <CustomCheckbox
                              name={`${group.groupName}_${subgroup.name}`}
                              value={`${group.groupName}_${subgroup.name}`}
                              label={subgroup.label}
                            />
                          </Grid>
                        ))}
                    </Grid>

                    <FormControl fullWidth className={classes.formControl}>
                      <Divider className={classes.divider} />
                    </FormControl>
                  </>
                ))}
              </Grid>
            </Grid>
          </FormControl>

          <Grid item xs={12}>
            <FormLabel className={classes.formTitles}>
              12) Hipóteses diagnósticas
            </FormLabel>

            <span> (Conforme Classificação Diagnóstica: 0-3)</span>

            <br />
            <br />

            <span>
              (Hipótese diagnóstica de acordo com os sintomas apresentados e
              descritos no momento da triagem. Marque o grupo diagnóstico abaixo
              e se possível, especifique a categoria)
            </span>

            <br />
            <br />

            <Grid container spacing={2}>
              <Grid item xs={12}>
                <FormLabel className={classes.formTitles}>
                  Eixo I: Diagnóstico Primário
                </FormLabel>
              </Grid>
              {renderList(hypotesisList)}

              <FormControl fullWidth className={classes.formControl}>
                <Divider className={classes.divider} />
              </FormControl>

              <Grid item xs={12}>
                <FormLabel className={classes.formTitles}>
                  Eixo II: Transtorno do Relacionamento
                </FormLabel>
              </Grid>
              {renderList(hypotesistList2)}
            </Grid>

            <Grid item xs={12}>
              {renderList(hypotesistList3)}
            </Grid>

            <Grid item xs={12}>
              {renderList(hypotesistList4)}
            </Grid>

            <Grid item xs={12}>
              {renderList(hypotesistList5)}
            </Grid>
          </Grid>

          <FormControl fullWidth className={classes.formControl}>
            <Divider className={classes.divider} />
          </FormControl>

          <FormControl fullWidth className={classes.formTitles}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <FormLabel className={classes.formTitles}>
                  Assinaturas
                </FormLabel>
              </Grid>

              <Grid item xs={12} justify="center">
                <Signatures
                  formAnswers={form ? form.answers : {}}
                  onSignature={setSignatures}
                />
              </Grid>
            </Grid>
          </FormControl>

          <FormControl fullWidth className={classes.formControl}>
            {/* <Divider className={classes.divider} /> */}
          </FormControl>

          <FormControl fullWidth className={classes.formTitles}>
            <Grid container spacing={1} justify="center">
              <Grid item>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => history.push(`/prontuarios/${id}`)}
                >
                  Voltar
                </Button>
              </Grid>

              <Grid item>
                <Button type="submit" color="primary" variant="contained">
                  Salvar
                </Button>
              </Grid>

              <Grid item>
                <Button
                  onClick={() => handleClickOpen()}
                  style={{ background: green[700], color: 'white' }}
                  variant="contained"
                >
                  Encaminhar
                </Button>
              </Grid>

              <Grid item>
                <a
                  href={`/prontuarios/${record?._id}/formularios/encerramento-atendimento`}
                  style={{
                    background: red[700],
                    color: 'white',
                    outline: 'none',
                    textDecoration: 'none',
                  }}
                >
                  <Button
                    onClick={() => console.log('Encerrar')}
                    style={{ background: red[700], color: 'white' }}
                    variant="contained"
                  >
                    Encerrar
                  </Button>
                </a>
              </Grid>
            </Grid>
          </FormControl>
        </Form>
      )}

      {alert.isActive && <Snackbar {...alert} />}
    </>
  );
};

export default BabyScreeningForm;
